<template>
  <div v-if="fields">
    <template v-if="where==='m'">
      <div @click.stop="$emit('pass', field.link)" v-for="(field, ind) in fields" :key="ind" class="row no-wrap link">
        <q-icon v-if="field.icon" :name="field.icon" />
        <div v-html="field.html" />
      </div>
    </template>
    <template v-else>
      <div v-for="(field, ind) in fields" :key="ind" v-html="field.html" />
    </template>
  </div>
</template>

<style scoped lang="stylus">
  @import '~variables'
  .link
    color $primary
    &:hover
      background-color white
</style>

<script>
import utils from '../others/utils.js';

const highlight = (s, term, media) => {
  const a = s.split(/\s+/).map((t) => {
    if (utils.termInStr(t.toLowerCase(), term)) {
      return `<span class="highlight">${t}</span>`;
    }
    return t;
  });
  if (media) {
    return { html: `<small>${a.join(' ')}</small>`, icon: utils.contentIcon(media.contentType), link: media.id };
  }
  return { html: `<small>${a.join(' ')}</small>` };
};

const getUnitField = (field, u, term) => {
  const map = {
    abb: 'abbr',
    add: 'address',
    cit: 'city',
    com: 'comment',
    ful: 'fullName',
    tel: 'telephones',
    nam: 'name',
    app: 'appointment',
  };
  if (map[field]) {
    if (field === 'tel') {
      return `<small>${utils.telStringLinks(u.telephones, term)}</small>`;
    }
    return highlight(u[map[field]], term);
  }
  return null;
};

const getCaseField = (field, c, term) => {
  const map = {
    pro: 'problem',
    res: 'result',
  };
  if (map[field]) {
    return highlight(c[map[field]], term);
  }
  if (field.startsWith('wt')) {
    const ind = parseInt(field.substr(2), 10);
    if (Number.isNaN(ind)) return null;
    if (c.works && c.works[ind]) {
      return highlight(c.works[ind].task, term);
    }
  }
  if (field.startsWith('ws')) {
    const ind = parseInt(field.substr(2), 10);
    if (Number.isNaN(ind)) return null;
    if (c.works && c.works[ind]) {
      return highlight(c.works[ind].short, term);
    }
  }
  return null;
};

const getMediaField = (field, u, term) => {
  const ind = parseInt(field.substr(2), 10);
  if (Number.isNaN(ind)) return null;
  if (u.medias && u.medias[ind]) {
    const mediaText = u.medias[ind].comment ? `${u.medias[ind].name} ${u.medias[ind].comment}` : u.medias[ind].name;
    return highlight(mediaText, term, u.medias[ind]);
  }
  return null;
};

export default {
  props: ['item'],
  components: { },
  computed: {
    term() {
      return this.$store.state.searchResults.term;
    },
    where() {
      return this.$store.state.searchResults.where;
    },
    fields() {
      const _fields = [];
      console.log('dddddddddd ************', this.where);
      if (this.where === 'm') {
        let u;
        if (this.item.id[0] === 'c') {
          u = this.$store.state.cases[this.item.id];
        } else {
          u = this.$store.state.units[this.item.id];
        }
        console.log('u ************', u);
        if (u) {
          this.item.fields.forEach((field) => {
            const f = getMediaField(field, u, this.term);
            console.log('f************', f);
            if (f) {
              _fields.push(f);
            }
          });
        }
      } else if (this.item.id[0] === 'c') {
        const c = this.$store.state.cases[this.item.id];
        if (c) {
          this.item.fields.forEach((field) => {
            const f = getCaseField(field, c, this.term);
            if (f) {
              _fields.push(f);
            }
          });
        }
      } else {
        const u = this.$store.state.units[this.item.id];
        if (u) {
          this.item.fields.forEach((field) => {
            const f = getUnitField(field, u, this.term);
            if (f) {
              _fields.push(f);
            }
          });
        }
      }
      return _fields;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/result-fields.vue